import {
  initialState,
  Actions,
  State,
  DELETE_CONTENT,
  DELETE_CONTENT_SUCCESS,
  DELETE_CONTENT_ERROR,
  RESET_DELETE_CONTENT,
} from '../../types/content/delete'

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case DELETE_CONTENT:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      }
    case DELETE_CONTENT_SUCCESS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      }
    case DELETE_CONTENT_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: action.payload,
          success: false,
        },
      }
    case RESET_DELETE_CONTENT:
      return {
        ...state,
        ...initialState,
      }
    default:
      return state
  }
}

export default reducers
